<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <path class="cls-2" d="m36.43,44.25h-16.49c-4.03,0-7.3-3.28-7.3-7.3v-16.49c0-4.03,3.28-7.3,7.3-7.3h16.49c4.03,0,7.3,3.28,7.3,7.3v16.49c0,4.03-3.28,7.3-7.3,7.3Zm-16.49-26.54c-1.52,0-2.75,1.23-2.75,2.75v16.49c0,1.52,1.23,2.75,2.75,2.75h16.49c1.52,0,2.75-1.23,2.75-2.75v-16.49c0-1.52-1.23-2.75-2.75-2.75h-16.49Z"/>
  <path class="cls-2" d="m69.66,44.25h-16.49c-4.03,0-7.3-3.28-7.3-7.3v-16.49c0-4.03,3.28-7.3,7.3-7.3h16.49c4.03,0,7.3,3.28,7.3,7.3v16.49c0,4.03-3.28,7.3-7.3,7.3Zm-16.49-26.54c-1.52,0-2.75,1.23-2.75,2.75v16.49c0,1.52,1.23,2.75,2.75,2.75h16.49c1.52,0,2.75-1.23,2.75-2.75v-16.49c0-1.52-1.23-2.75-2.75-2.75h-16.49Z"/>
  <path class="cls-2" d="m36.83,76.84h-16.49c-4.03,0-7.3-3.28-7.3-7.3v-16.49c0-4.03,3.28-7.3,7.3-7.3h16.49c4.03,0,7.3,3.28,7.3,7.3v16.49c0,4.03-3.28,7.3-7.3,7.3Zm-16.49-26.54c-1.52,0-2.75,1.23-2.75,2.75v16.49c0,1.52,1.23,2.75,2.75,2.75h16.49c1.52,0,2.75-1.23,2.75-2.75v-16.49c0-1.52-1.23-2.75-2.75-2.75h-16.49Z"/>
  <path class="cls-2" d="m70.06,76.84h-16.49c-4.03,0-7.3-3.28-7.3-7.3v-16.49c0-4.03,3.28-7.3,7.3-7.3h16.49c4.03,0,7.3,3.28,7.3,7.3v16.49c0,4.03-3.28,7.3-7.3,7.3Zm-16.49-26.54c-1.52,0-2.75,1.23-2.75,2.75v16.49c0,1.52,1.23,2.75,2.75,2.75h16.49c1.52,0,2.75-1.23,2.75-2.75v-16.49c0-1.52-1.23-2.75-2.75-2.75h-16.49Z"/>
  <rect class="cls-1" x="54.52" y="21.82" width="13.78" height="13.78" rx="2.38" ry="2.38"/>
</svg>
</template>

<script>
export default {
    name: "CategoryItemPerformanceIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #0f5b71;
  }
  .cls-2 {
    fill: #59c5c7;
  }
</style>